<template>
  <div class="miya-bottom-link">
    <div class="bottom-link-box">
      <div class="link-box">
        <div class="left-info">
          <img class="logo" src="@assets/images/home/miyaLOGO.svg">
          <div class="item" v-for="(item, idx) in infoList" :key="'info'+idx">
            <i class="icon" :class="`icon${idx + 1}`"></i>
            <div class="info">
              <p class="name">{{item.name}}</p>
              <p class="value">{{item.value}}</p>
            </div>
          </div>
        </div>
        <div class="right-link">
          <p class="title2">{{$t('home.lPolicy')}}</p>
          <p class="name" @click="showPolicy">{{$t('home.lmiyaPolicy')}}</p>
          <p class="title2">{{$t('home.lLink')}}</p>
          <div class="link-list">            
            <p class="name" v-for="(item, idx) in linkList" :key="'link'+idx" @click="clickLink(item)">{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="rights-box">
        <p class="name">{{$t('home.lTip')}}</p>
        <p class="title2">{{$t('home.lRights')}}</p>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogPolicy"  :width="pageWidth < 800 ? '86%':'40%'">
      <div class="textBox">  
        <p class="title2">{{$t('tos.t_1')}}</p>
        <p class="text2">{{$t('tos.c_11')}}</p>
        <p class="text2">{{$t('tos.c_12')}}</p>
        <p class="text2">{{$t('tos.c_13')}}</p>
        <p class="title2">{{$t('tos.t_2')}}</p>
        <p class="text2">{{$t('tos.c_21')}}</p>
        <p class="title2">{{$t('tos.t_3')}}</p>
        <p class="text2">{{$t('tos.c_31')}}</p>
        <p class="text2">{{$t('tos.c_32')}}</p>
        <p class="text2">{{$t('tos.c_33')}}</p>
        <p class="text2">{{$t('tos.c_34')}}</p>
        <p class="text2">{{$t('tos.c_35')}}</p>
        <p class="text2">{{$t('tos.c_36')}}</p>
        <p class="text2">{{$t('tos.c_37')}}</p>
        <p class="text2">{{$t('tos.c_38')}}</p>
        <p class="text2">{{$t('tos.c_39')}}</p>
        <p class="text2">{{$t('tos.c_310')}}</p>
        <p class="text2">{{$t('tos.c_311')}}</p>
        <p class="title2">{{$t('tos.t_4')}}</p>
        <p class="text2">{{$t('tos.c_41')}}</p>
        <p class="text2">{{$t('tos.c_42')}}</p>
        <p class="text2">{{$t('tos.c_43')}}</p>
        <p class="text2">{{$t('tos.c_44')}}</p>
        <p class="text2">{{$t('tos.c_45')}}</p>
        <p class="text2">{{$t('tos.c_46')}}</p>
        <p class="text2">{{$t('tos.c_47')}}</p>
        <p class="text2">{{$t('tos.c_48')}}</p>
        <p class="text2">{{$t('tos.c_49')}}</p>
        <p class="text2">{{$t('tos.c_410')}}</p>
        <p class="text2">{{$t('tos.c_411')}}</p>
        <p class="text2">{{$t('tos.c_412')}}</p>
        <p class="text2">{{$t('tos.c_413')}}</p>
        <p class="title2">{{$t('tos.t_5')}}</p>
        <p class="text2">{{$t('tos.c_51')}}</p>
        <p class="title2">{{$t('tos.t_6')}}</p>
        <p class="text2">{{$t('tos.c_61')}}</p>
        <p class="title2">{{$t('tos.t_7')}}</p>
        <p class="text2">{{$t('tos.c_71')}}</p>
        <p class="title2">{{$t('tos.t_8')}}</p>
        <p class="text2">{{$t('tos.c_81')}}</p>
        <p class="title2">{{$t('tos.t_9')}}</p>
        <p class="text2">{{$t('tos.c_91')}}</p>
        <p class="title2">{{$t('tos.t_10')}}</p>
        <p class="text2">{{$t('tos.c_101')}}</p>
        <p class="title2">{{$t('tos.t_11')}}</p>
        <p class="text2">{{$t('tos.c_11_1')}}</p>
        <p class="title2">{{$t('tos.t_12')}}</p>
        <p class="text2">{{$t('tos.c_121')}}</p><br/><br/>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      linkList: [],
      infoList: [],
      dialogPolicy: false,
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.infoList = [
        {name: this.$t('home.lTel'), value: '+1 7604621474'},
        {name: this.$t('home.lEmail'), value: 'amandamiller@miyaip.com'},
        {name: this.$t('home.lTime'), value: '9:00-18:00 PST'},
        {name: this.$t('home.lAddress'), value: '12655 W. Jefferson Blvd Los Angeles, CA, 90066'},
      ]
      this.linkList = [
        {name: 'hubstudio Fingerprint Browser', link: 'https://www.hubstudio.cn/?hub=Miya'},
        {name: 'mulogin Fingerprint Browser', link: 'https://www.mulogin.com/?ref=miyaip'},
        {name: 'Bit Fingerprint Browser', link: 'https://www.bitbrowser.cn/'},
        {name: 'AdsPower', link: 'https://app.adspower.net/registration?code=gfuoqq&source=share'},
        {name: 'vmlogin Fingerprint Browser', link: 'https://www.vmlogin.com.cn/?miya'},
        {name: 'yunlark Browser', link: 'https://www.yunlark.com/#'},
        {name: 'nest Browser', link: 'https://www.nestbrowser.com/'},
        {name: 'MoreLogin Fingerprint Browser', link: 'https://www.morelogin.com/?from=AAksnjV8d7Ku'},
        {name: 'Cross-border King (Cross-border Marketing software)', link: 'https://www.kuajingwang.vip/'},
        {name: 'luban', link: 'https://luban.bluemediagroup.cn/about/index?utm_source=miya'},
        {name: 'firebrowser', link: 'https://www.firebrowser.cn/?code=KF42LUJXPY'},
      ]
    },
    showPolicy () {
      this.dialogPolicy = true
    },
    clickLink (item) {
      window.open(item.link)
    },
  },
  watch: {
    language () {
      this.getData()
    },
  },
}
</script>
<style scoped lang="stylus">
.miya-bottom-link
  background: linear-gradient(104deg, #281E14 0%, #14110E 100%);
  padding 60px 0 32px 0
  .bottom-link-box
    width 1200px
    margin 0 auto 
    .link-box
      padding-bottom 20px
      display flex
      .left-info
        width 26%
        margin-right 18%
        .logo
          width 160px
          margin-bottom 40px
        .item
          display flex
          .icon1
            background url('../assets/images/home/l1.png')
          .icon2
            background url('../assets/images/home/l2.png')
          .icon3
            background url('../assets/images/home/l3.png')
          .icon4
            background url('../assets/images/home/l4.png')
          .icon
            width 40px
            height 40px
            background-size 100% 100%
            margin-right 16px
          .info
            flex 1
            margin-bottom 36px
            .name
              font-size $f16
              color #A3A3A3
              line-height 22px
              margin-bottom 4px
            .value
              font-size $f16
              color $c7
              line-height 26px
      .right-link
        flex 1
        .title2
          color $c7
          fontWeight()
          font-size $f20
          margin-bottom 32px
        .name
          font-size $f16
          line-height 22px
          color #D6D6D6
          cursor pointer
          margin-bottom 85px
          &:hover
            color $c8
        .link-list
          display flex
          flex-wrap wrap
          .name
            width 46%
            margin-right 8%
            margin-bottom 20px
            &:nth-of-type(2n)
              margin-right 0
  .rights-box
    padding-top 24px
    border-top 1px solid #7A7A7A
    .name
      font-size $f14
      color #D6D6D6
      line-height 20px
      text-align center
    .title2
      color #7A7A7A
      font-size $f16
      fontWeight()
      text-align center
      padding-top 20px
  .textBox   
    height 70vh
    overflow auto 
    .title1
      color $c1
      font-size 28px
      fontWeight()
      margin 10px 0 32px 0
    .title2
      font-size $f18
      color $c1
      fontWeight()
      margin 24px 0 12px 0
    .text2
      font-size $f14
      color $c2
      line-height 24px
@media screen and (max-width: 1200px) 
  .miya-bottom-link
    padding 1rem 0 0.5rem 0
    .bottom-link-box
      width 100%
      .link-box
        display block
        padding 0 1rem
        .left-info
          width 100%
          .logo
            width 100px
    .rights-box
      padding 0.5rem 1rem 0 1rem
</style>
<style lang="stylus">
.miya-bottom-link
  .el-dialog__body
    padding 12px 24px 24px 24px
</style>